





















// components
import DeathNotice from '@/components/DeathNotice.vue'
import Crosshair from '@/components/Crosshair.vue'
import { Component, Vue } from 'vue-property-decorator'
@Component({
  name: 'Index',
  components: {
    DeathNotice,
    Crosshair
  }
})
export default class Index extends Vue {
  isShowOtherPage = false

  created () {
    // todo
  }

  gotoIndex () {
    this.$router.push('/')
  }

  gotoDeathnotice () {
    this.$router.push('/death-notice')
  }

  gotoCrosshair () {
    this.$router.push('/crosshair')
  }

  otherClickFun () {
    // todo
    this.isShowOtherPage = true
  }
}
